import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PxWindow } from './PixelUI';
import { getSessionId, streamByte, mkMsgId } from '../api';
import { devWarn } from '../lib/log';

const MiniMessage = ({ msg }) => (
  <div className={`nv-msg ${msg.role}`} style={{ fontSize: 12, padding: '8px 10px' }}>
    {msg.text || 'checking the wire…'}
  </div>
);

// The little BYTE window that floats over the hero board — real model, real feed
const MiniByte = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [busy, setBusy] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages]);

  const appendDelta = (delta) => {
    setMessages((m) => {
      const copy = [...m];
      const last = copy[copy.length - 1];
      copy[copy.length - 1] = { ...last, text: last.text + delta };
      return copy;
    });
  };

  const send = async () => {
    const q = input.trim();
    if (!q || busy) return;
    setInput('');
    setBusy(true);
    setMessages((m) => [...m,
      { id: mkMsgId(), role: 'user', text: q },
      { id: mkMsgId(), role: 'bot', text: '' },
    ]);
    try {
      await streamByte(getSessionId(), q, appendDelta);
    } catch (err) {
      devWarn('[nanovram] mini byte stream failed:', err?.message);
      setMessages((m) => {
        const copy = [...m];
        copy[copy.length - 1] = { ...copy[copy.length - 1], text: 'byte is offline — give it a minute and retry' };
        return copy;
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <PxWindow
      title={<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>BYTE <span className="nv-live-dot" style={{ display: 'inline-block' }} /></span>}
      right={<span className="px-window-dots"><i /><i /></span>}
      tape
    >
      {messages.length > 0 && (
        <div ref={bodyRef} style={{ maxHeight: 180, overflowY: 'auto', padding: 12, display: 'flex', flexDirection: 'column', gap: 8, background: 'var(--nv-cream-2)' }}>
          {messages.map((m) => <MiniMessage key={m.id} msg={m} />)}
        </div>
      )}
      <div className="nv-chat-input">
        <input
          data-testid="mini-byte-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && send()}
          placeholder="type to byte"
        />
        <button className="px-btn sm" onClick={send} data-testid="mini-byte-send" disabled={busy}>Send</button>
      </div>
      <div style={{ textAlign: 'center', padding: '0 0 12px', background: 'var(--nv-cream)' }}>
        <Link to="/agent" style={{ fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--nv-brown)', fontWeight: 700 }} data-testid="open-full-console">
          Open the full console →
        </Link>
      </div>
    </PxWindow>
  );
};

export default MiniByte;
